var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.Active),expression:"Active"}],staticClass:"my-3",attrs:{"QuestionNo":_vm.QuestionNo}},[_c('pre',{staticClass:"break-word",staticStyle:{"white-space":"pre-line"},domProps:{"innerHTML":_vm._s(_vm.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }